export default {"src":"/_next/static/media/calendarThree_64.89ae51b0.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};